<template>
    <div>
        <header>
            <v-container>
                <v-row no-gutters>
                    <h1 class="font-weight-light headline">
                        {{ $t("title.settings") }}
                    </h1>
                </v-row>
            </v-container>
        </header>
        <section class="py-7">
            <v-container>
                <v-row>
                    <v-col cols="12" sm="6" xl="4">
                        <v-card>
                            <v-card-title>{{
                                $t("settings.in_general")
                            }}</v-card-title>
                            <v-card-text>
                                <v-text-field
                                    v-model="
                                        settings.general_email.value
                                    "
                                    outlined
                                    dense
                                    :label="$t('settings.general_email')"
                                    @input="
                                        saveSetting(
                                            settings.general_email
                                        )
                                    "
                                ></v-text-field>
                                <v-text-field
                                    v-model="
                                        settings.test_frequency.value
                                    "
                                    type="number"
                                    outlined
                                    dense
                                    :label="$t('settings.test_frequency')"
                                    @input="
                                        saveSetting(
                                            settings.test_frequency
                                        )
                                    "
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <SnackMessage ref="SnackMessage" />
            </v-container>
        </section>
    </div>
</template>

<script>
import SnackMessage from "../components/SnackMessage";

export default {
    data() {
        return {
            settings: {
                general_email: {
                    key: "general_email",
                    value: "",
                    loading: true
                },
                test_frequency: {
                    key: "test_frequency",
                    value: "",
                    loading: true
                },
            }
        };
    },

    components: {
        SnackMessage
    },

    created() {
        this.getSettings();
    },

    methods: {
        async getSettings() {
            await axios
                .get("/api/settings", {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token
                    }
                })
                .then(response => {
                    let settings = Object.keys(this.settings).map(
                        i => this.settings[i]
                    );
                    response.data.forEach(function(item, index) {
                        let setting = settings.find(s => s.key === item.key);
                        if (setting) {
                            setting.value = item.value;
                            setting.loading = false;
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.$refs.SnackMessage.showMessage(
                        "general.error",
                        "error"
                    );
                });
        },
        async saveSetting($item) {
            if($item.value && $item.value != "0"){
                await axios
                .put(`/api/updateSetting`, $item, {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token
                    }
                })
                .then(response => {
                    this.$refs.SnackMessage.showMessage(
                        "settings.setting_saved",
                        "success"
                    );
                })
                .catch(error => {
                    console.log(error);
                    this.$refs.SnackMessage.showMessage(
                        "general.error",
                        "error"
                    );
                });
            }
        },
    }
};
</script>
